/**
 * 静的リソース取得のリクエストを扱うモジュール
 */
import { sasStaticUrl } from '../urls';
import { createRequestId } from './http-request';

/**
 * BaseURLと結合してURLを返す
 */
const createUrl = (url: string) => {
  return url.match('^(http|https)://') ? url : sasStaticUrl + url;
};

/**
 * グロッサリ取得
 * GET /master/glossary/common_ja.json
 */
export const getGlossaryRequest = (filename: string, language?: string) => {
  const url = createUrl(
    `/master/glossary/${filename}${language ? `_${language}` : ''}.json`
  );
  const header = {
    'sas-client-request-id': createRequestId()
  };
  return {
    url: url,
    config: {
      method: 'GET',
      headers: header
    }
  };
};

/**
 * 国マスター取得
 * GET /master/country/country_master.json
 */
export const getCountryMasterRequest = () => {
  const url = createUrl('/master/country/country_master.json');
  const header = {
    'sas-client-request-id': createRequestId()
  };
  return {
    url: url,
    config: {
      method: 'GET',
      headers: header
    }
  };
};

/**
 * 言語マスター取得
 * GET /master/language/language_master.json
 */
export const getLanguageRequest = () => {
  const url = createUrl('/master/language/language_master.json');
  const header = {
    'sas-client-request-id': createRequestId()
  };
  return {
    url: url,
    config: {
      method: 'GET',
      headers: header
    }
  };
};
